import { createSlice } from "@reduxjs/toolkit";


export const livraisonSlice = createSlice({
    name: 'livraison',
    initialState:{},
    reducers: { //modify the selected spot in global state
        setLivraison: (currentState, action) => {
            
            return action.payload //action.payload is the new livrasion object (valid, secteur, adresse,comp) sent by the dispatch call

        }
    }
});